export default "__VITE_ASSET__Cr44s5Td__"